import { NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { IProgramNews } from '@model/program-news.model';
import { ActivatedRoute, RouterLink } from '@angular/router';

@Component({
  selector: 'jhi-news',
  templateUrl: './news.component.html',
  imports: [RouterLink, NgIf],
  standalone: true,
})
export class NewsComponent implements OnInit {
  record?: IProgramNews;

  constructor(protected activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.activatedRoute.data.subscribe(({ record }) => {
      this.record = record;
    });
  }

  getDescription(): string {
    if (this.record && this.record.descriptionPT) {
      return this.record.descriptionPT.replace(/<[^>]*>/g, '');
    }
    return '';
  }
}
